import invert from './invert.js';
import escapeMap from './_escapeMap.js';

// Internal list of HTML entities for unescaping.
export default invert(escapeMap);



//////////////////
// WEBPACK FOOTER
// ./node_modules/underscore/modules/_unescapeMap.js
// module id = 339
// module chunks = 0 1